export default "__VITE_ASSET__CrXDAwEr__"